module.exports = __webpack_public_path__ + "img/subscription_noti.5a13789.svg";